import NavLinks from './NavLinks'

export default NavLinks
